module.exports = __webpack_public_path__ + "media/landing_page/lp4-hero-mobile-03-e963a50f.jpg";